export function AxiosErrorException (err) {
	let errorJSON = err.response.data.errors;
	let errorStr = "";

	if(errorJSON) {
		Object.keys(errorJSON).forEach((item) => {
			errorStr += errorJSON[item] + "\n";
		})
	}
	else if(err.response.data.message){
		errorStr = err.response.data.message;
	}

	return errorStr
}